<template>
    <div class="videoDiv" @click="$router.push(`/emrClass/detail?id=${encodeURIComponent(cardData.Id)}`)" :style="{background:`url(${cardData.Cover})no-repeat`,backgroundSize:'cover',}">
        <p>{{cardData.title}}</p>
        <div class="icon-play"></div>
    </div>
</template>
<script>
export default {
  name: "videoDiv",
  props: {
    cardData: {
      type: Object
    }
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
.videoDiv {
  width: 245px;
  height: 150px;
  background: no-repeat;
  position: relative;
  display: flex;
  justify-content: center;
  cursor: pointer;
  transition: .2s;
  &:hover {
    // background-color: rgba(0, 0, 0, 0.2)!important;
    // filter: blur(2px);
    opacity: .85;
    .icon-play {
      opacity: .9;
    }
  }
  .icon-play {
    width: 0;
    height: 0;
    margin-top: 60px;
    border-top: 15px solid transparent;
    border-left: 24px solid #fff;
    border-bottom: 15px solid transparent;
    opacity: .5;
    transition: .2s;
  }
  p {
    font-size: 16px;
    color: #ffffff;
    position: absolute;
    bottom: 16px;
  }
}
</style>

